module.exports = __webpack_public_path__ + "static/media/packed-img.c8a628b3.jpg";